const percentages = `
  1. What do these percentages tell us about our discussion? <br /> <br />
  2. Is it important for everyone to comment? Why or why not? <br /> <br />
  3. Is it important for everyone to receive feedback? Why or why not? <br /> <br />
  4. How might we improve these numbers in future Written Roundtables?
`;

const comment_length = `
  1. Why does the average word length of our peer comments/feedback matter? <br /> <br />
  2. Does the number of words in a comment reflect the quality of the comment? <br /> <br />
  3. How can we improve in our next Written RoundTable?
`;

const word_cloud = `
  1. What words stood out? Did any surprise you? Why or why not? <br /> <br />
  2. Were there any words you thought would be more prominent but were not? <br /> <br />
  3. What themes or perspectives stick out in this word cloud?
`;

const model_submissions = `
  1. Why do you think these were selected as "model submissions"? <br /> <br />
  2. Was there anything interesting in the comments below the submission? <br /> <br />
  3. What can we learn from these model submissions to improve our next Written RoundTable?
`;

const comment_chord = `
  1. Was this a balanced conversation or did a few voices dominate? <br /> <br />
  2. Were there many students who didn’t provide any comments or replies? <br /> <br />
  3. Overall, did we respond to many comments or replies to develop the conversation or was there a lot of one way communication?
`;

export default {
  percentages,
  comment_length,
  word_cloud,
  model_submissions,
  comment_chord,
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/components/roundtableSummary/reflectionQuestions.js